import type { ResolutionDetails } from '@openfeature/web-sdk';
import { ErrorCode } from '@openfeature/web-sdk';
import type { LDEvaluationDetail } from 'launchdarkly-js-client-sdk';

const translateErrorKind = (kind?: string): ErrorCode => {
  switch (kind) {
    case 'CLIENT_NOT_READY':
      return ErrorCode.PROVIDER_NOT_READY;
    case 'MALFORMED_FLAG':
      return ErrorCode.PARSE_ERROR;
    case 'FLAG_NOT_FOUND':
      return ErrorCode.FLAG_NOT_FOUND;
    case 'USER_NOT_SPECIFIED':
      return ErrorCode.TARGETING_KEY_MISSING;
    default:
      return ErrorCode.GENERAL;
  }
};

export const translateResult = <T>(result: LDEvaluationDetail): ResolutionDetails<T> => {
  const base: ResolutionDetails<T> = {
    value: result.value,
    variant: result.variationIndex?.toString(),
    reason: result.reason?.kind,
  };
  if (result.reason?.kind === 'ERROR') {
    return { ...base, errorCode: translateErrorKind(result.reason.errorKind) };
  }
  return base;
};
